const zh = {
  "lines": [
    "嘘！你找到我了吗？",
    "哇！只是来看看你。",
    "别告诉别人我在这里……",
    "我好像闻到了华夫饼的香味……",
    "你看见我的瀑布了吗？",
    "嘘……我在躲巨魔猎人！",
    "继续往下滑——我在看着你！",
    "到 2 月 1 日了吗？"
  ],
  "giant": [
    "下面的你好呀！",
    "是谁在我的桥上滑来滑去？",
    "不是我大，是你太小。"
  ],
  "golden": "你发现了黄金巨魔！只有少数幸运儿见过我。",
  "goldenTag": "传说"
};

export default zh;
